/**
 * Post-login window used to avoid immediate 401 session-clear right after a successful login.
 *
 * Consumer map:
 *   - setLoginJustHappened / isWithinPostLoginGrace / resetPostLoginGrace
 *     → `authSessionApi` (clearSession, logout), UIs that complete login
 */

const POST_LOGIN_GRACE_MS = 4000;

let last_login_at = 0;

export function setLoginJustHappened(): void {
  last_login_at = Date.now();
}

export function isWithinPostLoginGrace(): boolean {
  return Date.now() - last_login_at < POST_LOGIN_GRACE_MS;
}

/** Call from logout so the next 401 is not mis-attributed to a previous login. */
export function resetPostLoginGrace(): void {
  last_login_at = 0;
}
